import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paymentContainer: {
    textAlign: "left",
  },

  pageTitle: {
    fontSize: "3rem",
    fontWeight: 800,
    letterSpacing: "-0.02em",

    color: theme.palette.text.billingtitle,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem",
    },
  },

  pageSubtitle: {
    color: theme.palette.text.paymentTitle,
    fontSize: "1.125rem",
    maxWidth: 570,
    lineHeight: 1.6,
    marginBottom: theme.spacing(6),
  },

  radioGroup: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    width: "100%",
  },

  formControlLabel: {
    margin: 0,
    width: "100%",
    "& .MuiFormControlLabel-label": {
      width: "100%",
    },
  },

  paymentCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(4),
    borderRadius: 12,
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    border: `1px solid ${theme.palette.text.impactText}`,
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      borderColor: theme.palette.text.step,
      transform: "translateY(-2px)",
    },
  },

  paymentCardActive: {
    backgroundColor: "rgba(255, 255, 255, 0.1) !important",
    borderColor: "rgba(6, 232, 159, 0.3) !important",
    boxShadow: "0 8px 24px rgba(6, 232, 159, 0.1)",
  },

  paymentCardDisabled: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(4),
    borderRadius: 12,
    backgroundColor: "rgba(255, 255, 255, 0.02)",
    border: "1px solid rgba(255, 255, 255, 0.03)",
    opacity: 0.4,
    cursor: "not-allowed",
  },

  cardContent: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
  },

  iconWrapper: {
    width: 48,
    height: 48,
    borderRadius: 8,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#06e89f",
    flexShrink: 0,
    transition: "all 0.3s ease",
    "$paymentCard:hover &": {
      backgroundColor: "rgba(6, 232, 159, 0.15)",
      transform: "scale(1.05)",
    },
  },

  iconWrapperDisabled: {
    width: 48,
    height: 48,
    borderRadius: 8,
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.paymentDisabled,
    flexShrink: 0,
  },

  cardTitle: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: theme.palette.text.billingtitle,
    marginBottom: 4,
  },

  cardTitleDisabled: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: theme.palette.text.cardTitle,
    marginBottom: 4,
  },

  cardBadges: {
    display: "flex",
    gap: 8,
    marginTop: 4,
    "& span": {
      fontSize: "0.75rem",
      textTransform: "uppercase",
      letterSpacing: "-0.02em",
      color: theme.palette.text.cardBadges,
    },
  },

  walletBalance: {
    fontSize: "0.875rem",
    color: "#06e89f",
    fontWeight: 600,
    marginTop: 4,
  },

  insufficientBalance: {
    fontSize: "0.875rem",
    color: theme.palette.text.cardTitle,
    fontWeight: 500,
    marginTop: 4,
  },

  radioCircle: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    border: "2px solid rgba(255, 255, 255, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    flexShrink: 0,
  },

  radioCircleActive: {
    borderColor: "#06e89f",
    backgroundColor: "#06e89f",
  },

  radioCircleDisabled: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    border: `2px solid ${theme.palette.text.checkboxPayment}`,
    flexShrink: 0,
  },

  radioDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#000c61",
    transform: "scale(0)",
    transition: "transform 0.2s ease",
  },

  radioDotActive: {
    transform: "scale(1)",
  },

  termsContainer: {
    marginTop: theme.spacing(6),
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    maxWidth: 570,
  },

  checkbox: {
    color: theme.palette.text.checkboxPayment,
    padding: 0,
    marginTop: 2,
    "&.Mui-checked": {
      color: "#006c48",
    },
  },

  termsText: {
    fontSize: "0.875rem",
    color: theme.palette.text.cardBadges,
    lineHeight: 1.6,
  },

  termsLink: {
    color: "#06e89f",
    textDecoration: "none",
    fontWeight: 600,
    "&:hover": {
      textDecoration: "underline",
    },
  },

  actionsContainer: {
    marginTop: theme.spacing(6),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
    flexWrap: "wrap",
  },

  btnPayment: {
    backgroundColor: "#006c48",
    // color: theme.palette.text.billingtitle,
    color: "#ffffff",
    padding: "20px 48px",
    borderRadius: 12,
    fontWeight: 800,
    fontSize: "0.875rem",
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    boxShadow: "0 20px 40px rgba(0, 108, 72, 0.2)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#005a3c",
      boxShadow: "0 24px 48px rgba(0, 108, 72, 0.3)",
      transform: "translateY(-2px)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 108, 72, 0.3)",
      color: "rgba(255, 255, 255, 0.3)",
      boxShadow: "none",
    },
  },

  btnBack: {
    color: theme.palette.text.paymentBack,
    textTransform: "uppercase",
    letterSpacing: "0.15em",
    fontSize: "0.75rem",
    fontWeight: 700,
    padding: "12px 24px",
    transition: "all 0.3s ease",
    "&:hover": {
      color: theme.palette.text.billingtitle,
      backgroundColor: "rgba(255, 255, 255, 0.05)",
    },
  },
}));

export default useStyles;
